<template>
  <section class="aicy-page-wrapper">
    <div class="content-box">
      <p class="aicy-desc">懂你所需的 Aicy 助手</p>
      <m-video
        class="end_video"
        src="@/auto/assets/video/assistant.mp4"
        poster="@/auto/assets/video/assistant.png"
        width="100%"
        muted
        loop
        ref="end_video"
      ></m-video>
    </div>
    <div class="seat"></div>
  </section>
</template>

<script>
import { videoPlayByVisibleArea } from '@/utils'

export default {
  name: 'Interconnection',
  methods: {
    videoRunner() {
      const end_video = this.$refs.end_video

      end_video && videoPlayByVisibleArea(end_video)
    },
    // pagePin() {
    //   this.$gsap.timeline({
    //     scrollTrigger: {
    //       trigger: '.aicy-page-wrapper',
    //       end: '+3500',
    //       pin: true,
    //     },
    //   })
    // },
    onPreload() {
      // this.pagePin()
      // this.airFontShow()

      this.videoRunner()
    },
  },
}
</script>

<style lang="less" scoped>
.seat {
  height: 3000px;
  width: 100%;
}
.aicy-desc {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 10.2%;
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  font-family: Flyme Sans VF;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 82px; /* 227.778% */
  letter-spacing: 2.16px;
}
.aicy-page-wrapper {
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  position: relative;
  background-color: #17181c;
  position: sticky;
  top: 0;
  .content-box {
    position: relative;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: #000;
  }
  .end_video {
    // border: 10px solid #000000;
    // border-radius: 12px;
    overflow: hidden;
  }
}
</style>
